import { c as _c } from "react/compiler-runtime";
import { FormSelect, Hint } from '@systemeio/ui';
import { WrapperChildrenPropsInterface } from 'modules/automation-rules/triggers/components/edit-triggers/components/edit-trigger-wrapper';
import { TriggerCourseItemProps } from 'modules/automation-rules/triggers/components/edit-triggers/components/trigger-course-item';
import { AutomationRuleTriggersDataEnum } from 'modules/automation-rules/triggers/enums/trigger-enum';
import { TriggerModuleEditInterface } from 'modules/automation-rules/triggers/types/automation-rule-triggers-edit-interface';
import { AutomationRuleBaseDataInterface } from 'modules/automation-rules/types/automation-rule-interface';
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import React from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface ModuleSelectProps extends Omit<TriggerCourseItemProps, 'onDelete' | 'triggers' | 'setRules' | 'idx' | 'trigger' | 'type'>, Pick<WrapperChildrenPropsInterface, 'onOpen'> {
  onChange: (data?: number) => void;
  moduleId?: number;
  triggerId: number;
  module: TriggerModuleEditInterface['module'];
  moduleData?: AutomationRuleBaseDataInterface[];
  hint: string;
}
const ModuleSelect = t0 => {
  const $ = _c(24);
  const {
    moduleId,
    triggerId,
    errors,
    onChange,
    onOpen,
    module,
    moduleData,
    hint,
    isStatic
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== onOpen) {
    t1 = () => onOpen(AutomationRuleTriggersDataEnum.module);
    $[0] = onOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("dashboard.course.module_title");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== hint || $[5] !== t2) {
    t3 = <Hint label={hint}>{t2}</Hint>;
    $[4] = hint;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("dashboard.automation_rule.trigger.choose_module");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== module) {
    t5 = module && getDataFromObj(module);
    $[9] = module;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== errors.automationTriggers || $[12] !== triggerId) {
    t6 = errors.automationTriggers[triggerId]?.module?.join("");
    $[11] = errors.automationTriggers;
    $[12] = triggerId;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== isStatic || $[15] !== moduleData || $[16] !== moduleId || $[17] !== onChange || $[18] !== t1 || $[19] !== t3 || $[20] !== t4 || $[21] !== t5 || $[22] !== t6) {
    t7 = <FormSelect disabled={isStatic} onOpen={t1} label={t3} placeholder={t4} value={moduleId} staticData={t5} data={moduleData} onChange={onChange} error={t6} />;
    $[14] = isStatic;
    $[15] = moduleData;
    $[16] = moduleId;
    $[17] = onChange;
    $[18] = t1;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
};
export default ModuleSelect;